import React, { useEffect, useState } from "react";
import { MainContext } from "./context/MainContext";
import { Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import { getDomainInfo } from "./utils/utils";
import { useSelector } from "react-redux";
import Home from "./pages/Home";
import EditProfile from "./pages/EditProfile";
import AppDownload from "./pages/AppDownload";
import CollectionDetails from "./pages/CollectionDetails";
import Cart from "./pages/Cart";
import AddPaymentAddress from "./pages/AddPaymentAddress";
import OrderSuccessfull from "./pages/OrderSuccessfull";
import OrderHistoryandSignOut from "./pages/OrderHistoryandSignOut";
import Login from "./pages/Login";
import OTPVerification from "./pages/OTPVerification";
import PaymentFailed from "./pages/PaymentFailed";
import OrderHistory from "./pages/OrderHistory";
import OrderConfirm from "./pages/OrderConfirm";
import ProductPreview from "./pages/ProductPreview";
import CommonProductDt from "./layout/CommonProductDt";
import Kyc from "./pages/Kyc";
import ConnectSkin from "./pages/ConnectSkin";
import "./assets/Styles/theme.scss";
import "./assets/Styles/mainStyle.scss";
import CategoryProductsPage from "./components/CategoryProductsPage/CategoryProductsPage";
import SearchResult from "./pages/SearchResult";
import Cart2 from "./pages/Cart2";
import CartDesignType from "./components/CartDesignType";
import { useVersionChecker } from "./hooks/useVersionChecker";
import Shop from "./pages/Shop";


function App() {
  const { isPredefinedDomain } = getDomainInfo();
  const { pathname } = useLocation();
  const userLogo = useSelector((state) => state.fetchUser?.user?.profileImg);
  const userTitle = useSelector((state) => state.fetchUser?.user?.name);
  const pixelId = useSelector((state) => state.fetchUser?.user?.pixelId);
  const storeName = localStorage.getItem('userid');
  const storeId = localStorage.getItem('storeid');
  const [ConnectUser, setConnectUser] = useState([]);
  const sessionToken = sessionStorage.getItem('token');

  useEffect(() => {
    if (!pixelId) return;

    if (!window.fbq) {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    }

    console.log("Initializing FB Pixel with ID:", pixelId);
    window.fbq('init', pixelId);
    console.log("after Initializing FB Pixel with ID:", pixelId);
    window.fbq('track', 'PageView');

  }, [pixelId]);

  // --- PAGE VIEW ON ROUTE CHANGE ---
  useEffect(() => {
    if (window.fbq && pixelId) {
      window.fbq('track', 'PageView');
    }
  }, [pathname, pixelId]);

  // --- META TAG & FAVICON LOGIC ---
  useEffect(() => {
    const setMetaTag = (property, content) => {
      let metaTag = document.querySelector(`meta[property='${property}']`);
      if (!metaTag) {
        metaTag = document.createElement("meta");
        metaTag.setAttribute("property", property);
        document.getElementsByTagName("head")[0].appendChild(metaTag);
      }
      metaTag.setAttribute("content", content);
    };

    if (userTitle) {
      setMetaTag("og:title", userTitle);
    }
    if (userLogo) {
      setMetaTag("og:image", userLogo);
    }

    const setFavicon = (faviconUrl) => {
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = faviconUrl;
      document.getElementsByTagName("head")[0].appendChild(link);
    };

    if (userLogo) {
      setFavicon(userLogo);
    }

    const setTitle = (titleText) => {
      const title =
        document.querySelector("title") || document.createElement("title");
      title.textContent = titleText;
      document.getElementsByTagName("head")[0].appendChild(title);
    };

    if (userTitle) {
      setTitle(userTitle);
    }
  }, [userLogo, userTitle]);

    useEffect(() => {
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "rzd0uomk3t");
  }, []);

  const navigate = useNavigate();
  const navigateToAppDownload = () => {
    return <Navigate to="/appdownload" />
  }
  // console.log("App component invoked");
  useVersionChecker(); // checks every 60 seconds

  return (
    <MainContext.Provider value={{}}>
      <Routes>

        <Route path={isPredefinedDomain ? "/:userId" : "/"} element={<Home />} />
        <Route path={isPredefinedDomain ? "/:userId/edit-profile" : "/edit-profile"} element={<EditProfile />} />
        <Route path="/appdownload" element={<AppDownload />} />
        <Route path={isPredefinedDomain ? "/:userId/otp-verification" : "/otp-verification"} element={<OTPVerification />} />
        <Route path={isPredefinedDomain ? "/:userId/myaccount" : "/myaccount"} element={<OrderHistoryandSignOut />} />
        <Route path={isPredefinedDomain ? "/:userId/shop" : "/shop"} element={<Shop />} />
        <Route path={isPredefinedDomain ? "/:userId/login" : "/login"} element={<Login />} />
        <Route path={isPredefinedDomain ? "/:userId/collectiondetails/:collectionName" : "/collectiondetails/:collectionName"} element={<CollectionDetails />} />
        <Route path={isPredefinedDomain ? "/:userId/cart" : "/cart"} element={<CartDesignType />} />
        {/* <Route path={isPredefinedDomain ? "/:userId/cart" : "/cart"} element={<Cart />} /> */}
        <Route path={isPredefinedDomain ? "/:userId/payment-failed" : "/payment-failed"} element={<PaymentFailed />} />
        <Route path={isPredefinedDomain ? "/:userId/productdetails/:productName" : "/productdetails/:productName"} element={<CommonProductDt />} />
        {/*<Route path={isPredefinedDomain ? "/:userId/add-payment-address" : "/add-payment-address"} element={<AddPaymentAddress />} />*/}
        <Route path={isPredefinedDomain ? "/:userId/order-successful" : "/order-successful"} element={<OrderSuccessfull />} />
        <Route path={isPredefinedDomain ? "/:userId/order-history" : "/order-history"} element={<OrderHistory />} />
        <Route path={isPredefinedDomain ? "/:userId/order-confirm" : "/order-confirm"} element={<OrderConfirm />} />
        <Route path={isPredefinedDomain ? "/:userId/product-preview" : "/product-preview"} element={<ProductPreview />} />
        <Route path={isPredefinedDomain ? "/:userId/category/:categoryTitle" : "/category-products"} element={<CategoryProductsPage/>} />
        <Route path={isPredefinedDomain ? "/:userId/search/" : "/search"} element={<SearchResult/>} />
        {/* <Route path="/:userId/connect" element={<ConnectSkin  />} /> */}
        <Route path="/Kyc" element={<Kyc />} />
      </Routes>
    </MainContext.Provider>
  );
}

export default App;
